module.exports = __webpack_public_path__ + "static/media/date_icon.b1354781.svg";